import { render, staticRenderFns } from "./CatalogDemandEnabled.vue?vue&type=template&id=5f8da88a&"
import script from "./CatalogDemandEnabled.vue?vue&type=script&lang=ts&"
export * from "./CatalogDemandEnabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports